import React from "react";
import Advertisment from "../Advertisments/Advertisment";
import MaintenancePackage from "../MaintenancePackage/MaintenancePackage";
import imgWarranty from "../../Assets/Image/line.PNG";
import "./Home.css";
import { Helmet } from "react-helmet";

export default function Home() {
  return (
    <>
      <Helmet>
        <title>VEHEX</title>
      </Helmet>
      <Advertisment />
      <MaintenancePackage />
      <div
        className="quality text-center fs-2 fw-700 second-color px-3"
        id="quality"
      >
        <span className="d-block">How to maintain your warranty ?</span>
        <span> كيف تحافظ علي ضمان سيارتك ؟</span>
        <div className="line position-absolute">
          <img
            src={imgWarranty}
            className="w-100"
            height={30}
            alt="imgWarranty"
          />
        </div>
      </div>
      {/* ================================== */}
      <div className="warrantyElements container py-5 d-flex justify-content-between gap-3">
        <div className="element bg-rating-color position-relative">
          <span className=" d-block">Justified</span>
          <span>معقولة</span>
          <i class="fa-solid fa-sack-dollar position-absolute fs-1"></i>
        </div>
        <div className="element bg-rating-color position-relative">
          <span className=" d-block">Simplified</span>
          <span>سهلة</span>
          <i class="fa-solid fa-right-left position-absolute fs-1"></i>
        </div>
        <div className="element bg-rating-color position-relative">
          <span className=" d-block">Certified</span>
          <span>معتمدة</span>
          <i class="fa-solid fa-handshake position-absolute fs-1"></i>
        </div>
      </div>
    </>
  );
}
